import { call, put, select } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import { setBannerAPIRequestState } from '../../../effects/message';
import { accountLoading } from '../../../effects/organization';

export default function* verifyBankAccount({ id, amounts }) {
  yield put(accountLoading(id));
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/billing/bank-accounts/${id}`;
  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.POST,
    body: { amounts },
  });
  if (!error && success) {
    yield put(
      setBannerAPIRequestState({
        bannerState: 'success',
        bannerMessage: 'Your ACH account has been successfully verified!',
      }),
    );
  } else {
    console.error(error);
    yield put(
      setBannerAPIRequestState({
        bannerState: 'error',
        bannerMessage:
          'Your ACH account could not be verified with the amounts provided.',
      }),
    );
  }
}
